import './style.css'

export default class Error404 {
    static selector = '.error404page'

    constructor(block) {
        this.block = block
    }
}
